"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicPurchaseServiceV3 = void 0;
const tslib_1 = require("tslib");
const purchase_1 = require("./purchase");
const purchase_2 = require("@wix/wix-vod-gql-api/dist/src/public/purchase/purchase");
class PublicPurchaseServiceV3 extends purchase_1.PublicPurchaseService {
    constructor(authorization, baseUrl) {
        super();
        this.purchaseService = new purchase_2.PurchaseService(authorization, baseUrl);
    }
    createOrder(videoId, channelId, paymentType, siteUrl, instance, compId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.purchaseService.createOrder(videoId, channelId, paymentType);
        });
    }
    getPaymentStatus(videoId, channelId, orderId, transactionId, instance, paymentType) {
        return this.purchaseService.getOrderStatus(videoId, channelId, paymentType);
    }
    cancelOrder(channelId, siteUrl, instance) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.purchaseService.cancelOrder(channelId);
        });
    }
}
exports.PublicPurchaseServiceV3 = PublicPurchaseServiceV3;
//# sourceMappingURL=purchase.v3.js.map